import { Button, Grid2, GridSize } from "@mui/material";
import { ReactNode } from "react";
type GridSizes = {
	lg?: GridSize;
	md?: GridSize;
	sm?: GridSize;
	xs?: GridSize;
};
type Props = {
	label: string;
	dataTestId?: string;
	showCreateModal: boolean;
	setShowCreateModal: (showCreateModal: boolean) => void;
	sizes?: GridSizes;
	legend?: ReactNode;
};

export const FooterButton = ({
	label,
	dataTestId,
	showCreateModal,
	setShowCreateModal,
	sizes = { lg: 2, md: 2, sm: 6, xs: 6 },
	legend,
}: Props) => {
	return (
		<Grid2
			container
			justifyContent={legend ? "space-between" : "flex-end"}
			alignItems="center"
			spacing={1}
			sx={legend ? { width: "100%" } : undefined}
		>
			{legend}
			<Grid2
				size={{
					xs: sizes.xs,
					sm: sizes.sm,
					md: sizes.md,
					lg: sizes.lg,
					xl: sizes.lg,
				}}
				sx={{
					display: "flex",
					justifyContent: "flex-end",
				}}
			>
				<Button
					variant="contained"
					color="primary"
					data-test-id={dataTestId}
					fullWidth
					onClick={() => setShowCreateModal(!showCreateModal)}
				>
					NEW {label}
				</Button>
			</Grid2>
		</Grid2>
	);
};
